import { render, staticRenderFns } from "./LCard.vue?vue&type=template&id=590d8b6e"
import script from "./LCard.vue?vue&type=script&lang=ts"
export * from "./LCard.vue?vue&type=script&lang=ts"
import style0 from "./LCard.vue?vue&type=style&index=0&id=590d8b6e&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports